import React from 'react';
import { ResponsiveLayout } from '@/components/ResponsiveLayout';

export default function ChannelAnalyticPage() {
  return (
    <ResponsiveLayout><div className="flex-1 min-h-screen bg-[#0A0A0B] text-[#F8F9FA]">
      
      <main className="flex-1 px-4 md:px-6 lg:px-8 py-6 md:py-8">
        <div className="mb-6">
          <h1 className="text-4xl font-bold font-heading text-[#F8F9FA] mb-2">
            Channel Analytic
          </h1>
          <p className="text-[#ADB5BD]">Telegram Channel Analytics (TGStat)</p>
        </div>
        <div className="border border-[#FFB703] bg-[#FFB703]/5 rounded-lg p-8 text-center">
          <p className="text-lg text-[#FFB703] mb-2">📊 Coming Soon</p>
          <p className="text-[#ADB5BD]">TGStat integration akan aktif dari 2026 onwards</p>
          <p className="text-sm text-[#6C757D] mt-4">Features: Subs in/out, Engagement rate, Views, Posts analysis</p>
        </div>
      </main>
    </div>
    </ResponsiveLayout>
  );
}
